import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FileThumbnailContainer = styled.figure`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 47px;
  height: 47px;
  margin-right: ${Spacing.S8};
  padding: ${Spacing.S4};
  border: 1px solid ${Color.Grey200};
  background-color: ${Color.White};
  overflow: hidden;
`
